<template>
  <div class="contact-page">
    <section class="contact-hero">
      <p class="eyebrow">ubuHle support</p>
      <h1>Contact Us</h1>
      <p>
        We're here to help. Reach out for booking support, salon partnerships, or general questions.
      </p>
      <div class="contact-actions">
        <router-link to="/" class="ghost-link">Back to home</router-link>
        <router-link to="/legal/privacy-policy" class="ghost-link ghost-link--accent">Privacy policy</router-link>
      </div>
    </section>

    <section class="contact-grid">
      <article class="contact-card">
        <span class="contact-icon"><i class="bi bi-headset"></i></span>
        <h2>General Support</h2>
        <p>Questions about bookings, services, or account issues.</p>
        <a href="mailto:support@ubuhle.co.za">support@ubuhle.co.za</a>
        <a href="tel:+27824503880">+27 (0) 82 450 3880</a>
        <div class="hours">
          <strong>Support Hours</strong>
          <span>Mon - Fri: 8:00 AM - 6:00 PM (SAST)</span>
          <span>Sat: 9:00 AM - 3:00 PM (SAST)</span>
        </div>
      </article>

      <article class="contact-card">
        <span class="contact-icon"><i class="bi bi-briefcase"></i></span>
        <h2>Business Inquiries</h2>
        <p>Partnerships, salon registration, or business opportunities.</p>
        <a href="mailto:business@ubuhle.co.za">business@ubuhle.co.za</a>
        <a href="tel:+27824503880">+27 (0) 82 450 3880</a>
        <div class="hours">
          <strong>Business Hours</strong>
          <span>Mon - Fri: 9:00 AM - 5:00 PM (SAST)</span>
        </div>
      </article>

      <article class="faq-card">
        <p class="eyebrow">Frequently Asked Questions</p>
        <ul>
          <li>How do I book an appointment?</li>
          <li>Can I cancel or reschedule my appointment?</li>
          <li>How do I register my salon on the platform?</li>
          <li>What if I have issues with my booking?</li>
        </ul>
      </article>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContactUs'
}
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(255, 157, 0, 0.12), transparent 32%),
    linear-gradient(180deg, #111113 0%, #09090a 100%);
  color: #f5f2eb;
  padding: 32px clamp(20px, 4vw, 56px) 72px;
}

.contact-hero,
.contact-grid {
  max-width: 1060px;
  margin: 0 auto;
}

.contact-hero {
  padding: 28px 0 40px;
}

.eyebrow {
  margin: 0 0 14px;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #ff9d00;
  font-size: 0.74rem;
  font-weight: 800;
}

h1 {
  margin: 0;
  font-size: clamp(2.8rem, 6vw, 5rem);
  line-height: 0.95;
  letter-spacing: -0.04em;
}

.contact-hero p {
  color: rgba(245, 242, 235, 0.72);
  font-size: 1rem;
  line-height: 1.7;
  margin: 16px 0 0;
}

.contact-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 24px;
}

.ghost-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 18px;
  border-radius: 999px;
  color: #f5f2eb;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: #1d1d22;
  font-weight: 700;
}

.ghost-link--accent {
  background: rgba(255, 157, 0, 0.14);
  border-color: rgba(255, 157, 0, 0.22);
}

.contact-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.contact-card,
.faq-card {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(20, 20, 24, 0.96);
  border-radius: 24px;
  padding: 22px;
  backdrop-filter: blur(18px);
}

.contact-card {
  display: grid;
  gap: 12px;
}

.contact-icon {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: rgba(255, 157, 0, 0.92);
  color: #1b1304;
  font-size: 1.15rem;
}

.contact-card h2,
.faq-card h2 {
  margin: 0;
  font-size: 1.25rem;
}

.contact-card p,
.faq-card li,
.hours span {
  color: rgba(245, 242, 235, 0.76);
  line-height: 1.7;
}

.contact-card a {
  color: #f5f2eb;
  text-decoration: none;
  border-radius: 16px;
  padding: 14px 16px;
  background: #1f1f25;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.hours {
  display: grid;
  gap: 4px;
  margin-top: 4px;
}

.hours strong {
  color: #ffbe4d;
}

.faq-card {
  grid-column: 1 / -1;
}

.faq-card ul {
  margin: 0;
  padding-left: 18px;
}

.faq-card li + li {
  margin-top: 8px;
}

@media (max-width: 900px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
}
</style>